<template>
  <div>
    <BookingSaveHeader class="pa-1" :admin="isAdmin" />

    <BaseForm :bookingId="bookingId" />
    <TopInfo />
    <FlightInfo :bookingId="bookingId" />
    <TourGuide />
    <MotorCoach />
    <Checklist />
    <Notes fieldName="notes" />
    <Notes fieldName="invoice_notes" />
  </div>
</template>

<script>
import { BookingSaveHeader, BaseForm, TopInfo, TourGuide, MotorCoach, Notes, Checklist } from "@/modules/bookings";

import { FlightInfo } from "@/modules/bookings.flights";
export default {
  components: {
    BookingSaveHeader,
    BaseForm,
    TopInfo,
    FlightInfo,
    TourGuide,
    MotorCoach,
    Notes,
    Checklist,
  },
  computed: {
    isAdmin() {
      return this.$store.getters["isAdmin"];
    },
    bookingId() {
      return this.$store.getters["BookingStore/booking_id"];
    },
  },
};
</script>
